import { SurveyQuestion } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    items: [],
    item: {},
    totalCount: 0,
    loading: false
  },
  actions: {
    async fetch({ commit }, params) {
      const items = await SurveyQuestion.fetch(params)
      commit('changeState', { items })
    },
    async count({ commit }, params) {
      const totalCount = await SurveyQuestion.count(params)
      commit('changeState', { totalCount })
    },
    async create({ commit }, data) {
      await SurveyQuestion.create(data)
    },
    async update({ commit }, { id, ...data }) {
      await SurveyQuestion.update(id, data)
    },
    async remove({ commit }, id) {
      await SurveyQuestion.remove(id)
    }
  },
  mutations: {
    setState(state, { atr, value }) {
      state[atr] = value
    }
  },
  getters: {}
}
